import React, { useEffect, useState } from 'react';
import { Airport, AirportListResponse } from '../interfaces/airport'; // the interface you made
import { flightApi } from '../lib/api';

type Props = {
  open: boolean;
  onClose: () => void;
  onSelect: (airport: Airport) => void;
};

export default function AirportModal({ open, onClose, onSelect }: Props) {
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState<string | null>(null);
  const [airports, setAirports] = useState<AirportListResponse['data']>([]);

  useEffect(() => {
    if (!open) return;
    setLoading(true);
    setErr(null);
    flightApi.get<AirportListResponse>('/airports/getAll')
      .then(res => setAirports(res.data?.data ?? []))
      .catch(e => setErr(e?.message ?? 'Failed to load airports'))
      .finally(() => setLoading(false));
  }, [open]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
      <div className="w-full max-w-2xl rounded-xl bg-white shadow-xl">
        <div className="flex items-center justify-between border-b p-4">
          <h2 className="text-lg font-semibold">Choose an airport</h2>
          <button onClick={onClose} className="rounded px-2 py-1 text-gray-600 hover:bg-gray-100">Close</button>
        </div>
        <div className="p-4">
          {loading && <div className="py-8 text-center">Loading…</div>}
          {err && !loading && <div className="py-8 text-center text-red-600">{err}</div>}
          {!loading && !err && (
            <ul className="max-h-[60vh] divide-y overflow-y-auto">
              {airports.map(a => (
                <li key={a._id}>
                  <button
                    className="flex w-full items-center justify-between px-3 py-3 text-left hover:bg-gray-50"
                    onClick={() => { onSelect(a); onClose(); }}
                  >
                    <div>
                      <div className="font-medium">{a.code} — {a.name}</div>
                      <div className="text-sm text-gray-500">
                        {a.city}{a.city && a.country ? ', ' : ''}{a.country}
                      </div>
                    </div>
                    <span className="text-xs text-gray-500">Select</span>
                  </button>
                </li>
              ))}
              {airports.length === 0 && (
                <li className="py-8 text-center text-gray-600">No airports</li>
              )}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
}
